import { Calendar, Heart, Lock, Sparkles, Target, Zap } from 'lucide-react';

import { LogoText } from '@/components/logo-text';
import { landingContent } from '@/constants/landing-content';
import { cn } from '@/lib/utils';

const { benefits } = landingContent;

const iconMap = {
  Target,
  Sparkles,
  Calendar,
  Heart,
  Lock,
  Zap,
} as const;

export function BenefitsSection() {
  return (
    <section className="bg-muted/30 py-16 md:py-24">
      <div className="container mx-auto max-w-6xl px-4">
        <h2 className="text-foreground text-center text-3xl font-bold tracking-tight md:text-4xl">
          Por que casais amam o <LogoText inheritWeight />
        </h2>

        <div className="mt-12 grid auto-rows-[minmax(180px,auto)] gap-4 md:grid-cols-3">
          {benefits.items.map((item, index) => {
            const Icon = iconMap[item.icon as keyof typeof iconMap];
            const isLarge = item.size === 'large';

            return (
              <div
                key={index}
                className={cn(
                  'group relative flex flex-col justify-between overflow-hidden rounded-xl p-6',
                  'bg-background [box-shadow:0_0_0_1px_rgba(0,0,0,.03),0_2px_4px_rgba(0,0,0,.05),0_12px_24px_rgba(0,0,0,.05)]',
                  'dark:bg-background dark:[box-shadow:0_-20px_80px_-20px_#ffffff1f_inset] dark:[border:1px_solid_rgba(255,255,255,.1)]',
                  isLarge && 'md:col-span-2',
                )}
              >
                <div className="flex flex-col gap-3">
                  <div className="bg-primary/10 flex h-12 w-12 items-center justify-center rounded-lg">
                    <Icon className="text-primary h-6 w-6" />
                  </div>
                  <h3 className="text-foreground text-xl font-semibold">
                    {item.title}
                  </h3>
                  <p className="text-muted-foreground">{item.description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
